var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fight-room-item",
      class: { "is-crazy-mode": _vm.isCrazyMode == 1 },
    },
    [
      _c("div", { staticClass: "parts" }, [
        _c(
          "div",
          {
            staticClass: "battle-item__rounds-num",
            class: [
              { color1: _vm.room.roomState == 2 },
              { color2: _vm.room.roomState == 1 },
              { color3: _vm.room.roomState == 0 },
            ],
          },
          [_c("div", [_vm._v(" " + _vm._s(_vm.curCases.length) + " ")])]
        ),
      ]),
      _c("div", { staticClass: "id" }, [
        _vm._v(" " + _vm._s(_vm.room.id) + " "),
        _vm.isTeamMode == 1
          ? _c("span", { staticClass: "team-mode-tag" }, [_vm._v("团队赛")])
          : _vm._e(),
        _vm.isCrazyMode == 1
          ? _c("span", { staticClass: "crazy-mode-tag" }, [_vm._v("CRAZY")])
          : _vm._e(),
      ]),
      !_vm.$screen.mobile
        ? _c(
            "div",
            { staticClass: "gun-list" },
            _vm._l(_vm.curCases, function (room_case, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "img-con",
                  on: {
                    click: function ($event) {
                      return _vm.openCaseDetail(room_case)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "box-img" }, [
                    room_case.casePic
                      ? _c("img", {
                          attrs: {
                            src: _vm._f("imgfilter")(room_case.casePic),
                          },
                        })
                      : _vm._e(),
                    room_case.itemPic
                      ? _c("img", {
                          staticClass: "itempic",
                          attrs: {
                            src: _vm._f("imgfilter")(room_case.itemPic),
                          },
                        })
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "name" }, [
                    _c("span", [_vm._v(_vm._s(room_case.caseName))]),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _c("div", { staticClass: "status-con" }, [
        _c("div", { staticClass: "price" }, [
          _vm._v(" " + _vm._s(_vm.room.roomPrice) + " "),
          _vm.isHappyCoin
            ? _c("span", { staticStyle: { "font-size": "12px" } }, [
                _vm._v("欢乐豆"),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            staticClass: "status",
            class: [
              { wait: _vm.room.roomState == 0 },
              { run: _vm.room.roomState == 1 },
            ],
          },
          [
            _vm._v(
              " " + _vm._s(["等待", "运行", "结束"][_vm.room.roomState]) + " "
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "user-con" }, [
        _c("div", { staticClass: "round" }, [
          _vm._v(
            " " +
              _vm._s(_vm.joinUserList.length) +
              " / " +
              _vm._s(_vm.joinCount) +
              " "
          ),
        ]),
        _c(
          "div",
          { staticClass: "user-list" },
          [
            _vm._l(_vm.joinUserList, function (user) {
              return _c(
                "div",
                {
                  key: user.id,
                  staticClass: "img",
                  class: { isWin: user.isWinner && _vm.room.roomState == 2 },
                },
                [
                  _c("div", { staticClass: "mark-win" }),
                  _c("c-avatar", {
                    attrs: {
                      src: user.avatar
                        ? _vm.$imgfilter(user.avatar)
                        : require("@/assets/images/user/ava_none.jpg"),
                      vip: user.vipLevel,
                      is_streamer: user.isStreamer,
                      is_robot: user.isRobot,
                      curr_metal_url: user.currMetalUrl,
                    },
                  }),
                ],
                1
              )
            }),
            _vm._l(_vm.joinCount - _vm.joinUserList.length, function (n) {
              return _c("div", { key: n, staticClass: "img join" })
            }),
          ],
          2
        ),
      ]),
      _vm.$screen.mobile
        ? _c(
            "div",
            { staticClass: "gun-list" },
            _vm._l(_vm.curCases, function (room_case, index) {
              return _c("div", { key: index, staticClass: "box" }, [
                _c(
                  "div",
                  {
                    staticClass: "img-con",
                    on: {
                      "on-popper-show": function ($event) {
                        return _vm.openCaseDetail(room_case)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "box-img" }, [
                      room_case.casePic
                        ? _c("img", {
                            attrs: {
                              src: _vm._f("imgfilter")(room_case.casePic),
                            },
                          })
                        : _vm._e(),
                      room_case.itemPic
                        ? _c("img", {
                            staticClass: "itempic",
                            attrs: {
                              src: _vm._f("imgfilter")(room_case.itemPic),
                            },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "name" }, [
                        _vm._v(_vm._s(room_case.caseName)),
                      ]),
                    ]),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm._e(),
      _c("div", { staticClass: "enter" }, [
        _c(
          "div",
          {
            staticClass: "btn",
            class: {
              join: _vm.room.roomState == 0,
              lock: _vm.room.password != "",
            },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.handleShowRoomDetail(_vm.room)
              },
            },
          },
          [
            _vm._v(
              " " + _vm._s(_vm.room.roomState == 0 ? "进入" : "查看战斗") + " "
            ),
          ]
        ),
      ]),
      _c("div", { staticClass: "time" }, [
        _vm._v(_vm._s(_vm.room.updatedTime)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }